<script setup>
import { computed } from "vue";
import Button from "@/v2/primitives/Button/Button.vue";
import Icon from "@/v2/primitives/Icon/Icon.vue";

const props = defineProps({
  isLeft: {
    type: Boolean,
    required: true,
  },
  isOverlay: {
    type: Boolean,
    required: true,
  },
});

const componentClasses = computed(() => ({
  "slide-menu-button": true,
  "slide-menu-button--left": props.isLeft,
  "slide-menu-button--overlay": props.isOverlay,
}));
</script>

<template>
  <Button
    :class="componentClasses"
    tooltip="Close"
    tooltip-position="inline-start"
    variant="primary"
    :focus-theme="props.isOverlay ? 'light' : 'dark'"
    :data-dd="
      props.isOverlay ? 'Search Close Button' : 'Site Navigator Close Button'
    "
  >
    <template #left-icon>
      <Icon name="close" />
    </template>
  </Button>
</template>

<style scoped lang="scss">
@import "@/v2/styles/main";

.slide-menu-button {
  position: absolute;
  z-index: 2;
  background: var(--button-inverted-raised-surface);
  color: var(--button-inverted-raised-text);
  top: var(--spacing-base);
  left: var(--spacing-base);

  &--left {
    right: var(--spacing-base);
    left: auto;
  }

  @include min-width-md-and-height-md {
    &--overlay {
      top: 50%;
      transform: translateY(-50%);
    }

    &--overlay:not(.slide-menu-button--left) {
      left: calc(-4 * var(--spacing-base));
    }

    &--overlay.slide-menu-button--left {
      right: calc(-4 * var(--spacing-base));
    }
  }
}
</style>
